module.exports = __webpack_public_path__ + "img/5.844ad05c.jpg";